
<template>
  <div>
    <br />
    <b-row
      class="not-print"
      style="margin-left: 16px; margin-right: 40px"
      align-h="between"
    >
      <b-col md="6">
        <h2 class="text-primary" style="margin-bottom: 0px">
          <i class="mr-2 fas fa-chart-bar" />Relatório de Notas Fiscais
        </h2>
        <small class="text-muted"
          >Visualize aqui todas suas Notas fiscais.</small
        >
      </b-col>
      <b-col class="pr-0 text-right">
        <router-link class="mr-4 btn btn-primary" to="/nf-e">
          <i class="fas fa-arrow-left mr-2" />Voltar
        </router-link>
        <button type="button" class="btn btn-primary" @click="printReport()">
          <i class="fas fa-print mr-2" />Imprimir Relatório
        </button>
      </b-col>
    </b-row>
    <b-row
      class="not-print"
      style="margin-left: 16px; margin-right: 40px"
      align-h="between"
    >
      <b-col>
        <invoice-report-filter
          ref="InvoiceReportFilter"
          @filter="search()"
          v-model="searchForm"
        />
      </b-col>
    </b-row>

    <div class="row" style="margin: 3px">
      <div class="col">
        <b-card
          align-v="start"
          dense
          :title="company.name"
          header="Relatório de Notas Fiscais"
          class="text-center"
        >
          <b-card-text>
            <b-container>
              <b-row>
                <b-col align-h="start">
                  <small v-if="company.person_type == 'j'"
                    >CNPJ: {{ company.cnpj | VMask("##.###.###/####-##") }}
                  </small>
                  <small v-if="company.person_type == 'f'"
                    >CPF: {{ company.cpf | VMask("###.###.###-##") }}
                  </small>
                  <br />
                  <small v-if="company.phone_wa != null"
                    >Whatsapp:{{
                      company.phone_wa | VMask("(##) # ####-####")
                    }}
                    |</small
                  >
                  <small v-if="company.phone2 != null"
                    >Telefone:
                    {{ company.phone2 | VMask("(##) ####-###") }} |</small
                  >
                  <small> E-mail: {{ company.email1 }}</small>
                </b-col>
                <b-col>
                  <small>{{ company.address.address }}, </small>
                  <small>{{ company.address.number }}, </small>
                  <small>{{ company.address.complement }}, </small>
                  <small>{{ company.address.district }} </small>
                  <br />
                  <small>{{ company.address.city }}-</small>
                  <small>{{ company.address.state }}, </small>
                  <small v-if="company.address.zipcode != null">
                    CEP:
                    {{ company.address.zipcode | VMask("#####-###") }}</small
                  >
                </b-col>
              </b-row>
            </b-container>
          </b-card-text>

          <b-row>
            <b-col>
              <div class="row justify-content-start">
                <div v-if="searchForm.date_start" class="col">
                  <span class="font-weight-bold">Data inicial:</span>
                  {{ searchForm.date_start | dateBr }}
                </div>
                <div v-if="searchForm.date_end" class="col">
                  <span class="font-weight-bold">Data Final:</span>
                  {{ searchForm.date_end | dateBr }}
                </div>
              </div>
            </b-col>
            <b-col>
              <div class="row mr-2 justify-content-end">
                <span class="font-weight-bold">Consulta Realizada :</span>
                {{ date | dateTimeBr }}
              </div>
            </b-col>
          </b-row>
        </b-card>
      </div>
    </div>
    <div class="row" style="margin: 3px">
      <div class="col">
        <div class="card">
          <table class="table">
            <thead>
              <tr>
                <th scope="col">Número</th>
                <th scope="col">Emissão</th>
                <th style="width: 7%" scope="col">Tipo</th>
                <th style="width: 1%; text-align: center">Mod./Série</th>
                <th scope="col">Nome</th>
                <th style="text-align: end">V. ICMS</th>
                <th style="text-align: end">B. ICMS</th>
                <th style="text-align: end">Desconto</th>
                <th style="width: 15%; text-align: center">Total</th>
                <th style="text-align: center">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in reportList" :key="index">
                <td style="text-align: center">{{ row.nNF }}</td>
                <td>{{ row.dhEmi | dateBr }}</td>
                <td>{{ setType(row.type) }}</td>
                <td style="text-align: center">
                  {{ row.mod }}/{{ row.serie }}
                </td>
                <td>{{ row.dest_xNome }}</td>
                <td style="text-align: end">{{ row.vICMS | decimal }}</td>
                <td style="text-align: end">{{ row.vBC | decimal }}</td>
                <td style="text-align: end">{{ row.vDesc | moneyBr }}</td>
                <td style="text-align: end">{{ row.vNF | moneyBr }}</td>
                <td style="text-align: center">{{ setStatus(row.status) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <table class="table">
          <thead style="text-align: right">
            <th>
              Valor total de notas Autorizada :
              {{ total_vNF.sum_vNF | moneyBr }}
            </th>
          </thead>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import InvoiceReportFilter from "./../../components/Filter/InvoiceReportFilter";

export default {
  components: {
    InvoiceReportFilter,
  },

  data: function () {
    return {
      visi: false,
      searchForm: {},
      reportList: {},
      total_vNF: {},
      isPrint: true,
    };
  },

  created() {
    this.search();
    this.$store.commit("pageHasLoaded");
  },

  computed: {
    company() {
      return this.$store.state.company;
    },
    date() {
      return moment().format();
    },
  },

  methods: {
    search(page = 1) {
      this.$store.commit("showLoading");

      this.$store
        .dispatch("invoice/getReport", this.searchForm)
        .then((response) => {
          this.reportList = response.data.report_list;
          this.total_vNF = response.data.authorizedValue;
          this.$store.commit("hideLoading");
        })
        .catch((error) => {
          this.$store.commit("hideLoading");

          this.error = error;
        });
    },

    printReport() {
      window.print();
    },

    setStatus(status) {
      if (status == "n") {
        return "NÃO ENVIADA";
      }

      if (status == "p") {
        return "PROCESSANDO";
      }

      if (status == "d") {
        return "DENEGADA";
      }

      if (status == "a") {
        return "AUTORIZADA";
      }

      if (status == "i") {
        return "INUTILIZADA";
      }

      if (status == "c") {
        return "CANCELADA";
      }
      if (status == "r") {
        return "REJEITADA";
      }
    },

    setType(type) {
      if (type == "nfe") {
        return "NF-e";
      }

      if (type == "nfce") {
        return "NFC-e";
      }
    },
  },
};
</script>


<style scoped>
body {
  margin: 0;
  padding: 0;
  background-color: #fafafa;
  color: rgb(0, 0, 0);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol";
  font-size: 11pt;
}

* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.page {
  width: 297mm;
  min-height: 210mm;
  padding: 0.5cm;
  margin: 0.5cm;
  border: 1px #d3d3d3 solid;
  /*    border-radius: 5px;*/
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}

.subpage {
  padding: 0cm;
  /*    border: 5px red solid;*/
  height: 256mm;
  outline: 2cm #ffeaea solid;
}

@page {
  size: A4;
  margin: 0.5cm;
  padding: 0.5cm;
}

@media print {
  .page {
    visibility: visible;
    margin: initial;
    border: rgba(0, 0, 0, 0.1);
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    page-break-after: always;
  }

  .not-print {
    display: none;
  }
}

hr.color {
  border: 1px solid black;
}
</style>
